/**
 * Activity-log helpers for the Versions summary timeline.
 *
 * Icon mapping follows the Figma Versions frame (Task Management
 * 3001:71735): refresh for prompt/config updates, check for parser
 * validation, uploaded for dataset/benchmark events, task for creation.
 */
import { stripCloneSuffixInText } from '@/features/datasets/utils/datasetCloneNames';

const DEFAULT_ICON = 'refresh';

export function activityLogIconSlug(displayName) {
  const name = String(displayName || '').toLowerCase();
  if (!name) return DEFAULT_ICON;
  if (name.includes('fail')) return 'circle-x';
  if (name.includes('parser') || name.includes('validat')) return 'circle-check';
  if (
    name.includes('upload') ||
    name.includes('dataset') ||
    name.includes('benchmark')
  ) {
    return 'uploaded';
  }
  if (name.includes('file')) {
    return 'file-upload';
  }
  if (name.includes('created')) return 'task';
  return DEFAULT_ICON;
}

export function activityLogSearchText(entry, formatDateTime) {
  const created = entry?.created_datetime
    ? formatDateTime(entry.created_datetime) || String(entry.created_datetime)
    : '';
  return [entry?.display_name, stripCloneSuffixInText(entry?.description), created]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
}

export function filterActivityLogEntries(entries, query, formatDateTime) {
  const list = Array.isArray(entries) ? entries : [];
  const q = String(query || '').trim().toLowerCase();
  if (!q) return list;
  return list.filter((entry) => activityLogSearchText(entry, formatDateTime).includes(q));
}
